export default `
    <svg id="cursor" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0L12 24" stroke="black"/>
        <path d="M24 12L0 12" stroke="black"/>
    </svg>
`;
